import { createFileRoute } from '@tanstack/react-router'
import { StockReportPage } from '@/features/reports/stock'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/reports/stock')({
  component: () => (
    <RequirePermission permission='report.stock.view'>
      <StockReportPage />
    </RequirePermission>
  ),
})
